import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Tag, Divider, Spin } from "antd";
import { CloseOutlined, PhoneOutlined } from "@ant-design/icons";
import "./trip-details-modal.scss";
import { CommonConstants } from "../../../constants/commonConstants";
import * as localStorageService from "../../../service/localStorageService";
import { LocalStorageKeys } from "../../../constants/localStorageKeys";
import { getOrderDetailsForInvoice } from "../../../service/earning-invoice/earning-invoice";
import { checkIsTurkeyKazak } from "../../../util/constantUtility";
import DecimalFormatter from "../../../common/decimal-converter/decimal-converter";
import { useTranslation } from "react-i18next";

const TripDetailsModal = ({ open, onClose, data,userData }) => {
  const { t } = useTranslation();
  const language = localStorageService.getValue(LocalStorageKeys.Lang)
    ? localStorageService.getValue(LocalStorageKeys.Lang)
    : CommonConstants.DefaultLanguageCode;
  console.log("selected data", data);

  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (open && data?.orderNumber) {
      fetchOrderDetails();
    }
  }, [open, data]);

  const fetchOrderDetails = async () => {
    try {
      setLoading(true);

      const payload = {
        orderNumber: data?.orderNumber,
        tripIds: data?.tripIds || [],
        languageISOCode: language,
      };

      const res = await getOrderDetailsForInvoice(payload);

      setDetails(res?.data?.data || null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const pickupPoint = details?.routePoints?.find((item) => item?.isPickup);

  const dropPoint = details?.routePoints?.find((item) => !item?.isPickup);
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      width={420}
      className="trip-modal"
    >
      {/* Header */}
      <div className="modal-header">
        <div className="title">{t("INV_UPL_TRIP_MODAL_ORDER_ID_HDR")} {details?.orderNumber}</div>

        <CloseOutlined onClick={onClose} className="close-icon" />
      </div>

      <Divider />

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "40px 0",
          }}
        >
          <Spin />
        </div>
      ) : (
        <>
          {/* Trip Details */}
          <div className="section-title">{t("INV_UPL_TRIP_MODAL_TRIP_DETAILS_HDR")}</div>

          {/* Pickup */}
          <div className="route">
            <div className="dot-line" />

            <div>
              <div className="location">{pickupPoint?.location?.address}</div>

              <div className="sub">{pickupPoint?.location?.country}</div>
            </div>
          </div>

          {/* Drop */}
          <div className="route">
            <div className="dot-line end" />

            <div>
              <div className="location">{dropPoint?.location?.address}</div>

              <div className="sub">{dropPoint?.location?.country}</div>
            </div>
          </div>

          <Divider />

          {/* Trips */}
          <div className="trip-card-body">
          {details?.trips?.map((trip, index) => (
            <div key={index} className="trip-card">
              <Row justify="space-between" align="middle">
                <div className="truck">
                  {t("INV_UPL_TRIP_MODAL_TRUCK_NO")} - <b>{trip?.assetRegistrationNumber}</b>
                </div>

                <Tag color="green">{trip?.localizeStatusName}</Tag>
              </Row>

              <div className="driver-label">{t("INV_UPL_TRIP_MODAL_DRIVER_NAME")}</div>

              <Row justify="space-between" align="middle">
                <div className="driver">{trip?.driverName}</div>

                <div className="phone">
                  <PhoneOutlined />&nbsp;
                  {trip?.driverContactDetails?.countryCode && (
                    <>+{trip?.driverContactDetails?.countryCode} </>
                  )}

                  {trip?.driverContactDetails?.mobileNumber}
                </div>
              </Row>

              <div className="earnings">
                {trip?.currency}&nbsp;
                {trip?.amount ? <DecimalFormatter amount={trip?.amount} country={checkIsTurkeyKazak(userData?.operatingCountry) ? "TRY" :trip?.currency} flag={false} isShowDecimal={true}/>:"0"}
                <span className="earnings-sub"> {t("INV_UPL_TRIP_MODAL_TOTAL_EARNINGS")}</span>
              </div>

              {index !== details?.trips?.length - 1 && <Divider />}
            </div>
          ))}
          </div>
        </>
      )}
    </Modal>
  );
};

export default TripDetailsModal;
